<script lang="ts">
	
	import {onMount} from "svelte";
	import { storeDomain } from "../scripts/store";

	onMount(async () => {
	});

</script>

<div class="domaineintro font-intro" class:domaineintro__amenagements={$storeDomain == "amenagements"}>
	<div class="domaineintro__habillage">
		{#if ($storeDomain == "services")}
			<img class="domaineintro__habillage__slash" src="../images/slash-services.png" alt="slash services">
		{:else}
			<img class="domaineintro__habillage__slash" src="../images/slash-amenagements.png" alt="slash amenagements">
		{/if}
		<div class="domaineintro__habillage__line" class:domaineintro__habillage__line__services={$storeDomain == "services"} class:domaineintro__habillage__line__amenagements={$storeDomain == "amenagements"}>&nbsp;</div>
		<div class="domaineintro__habillage__line__ext" class:domaineintro__habillage__line__ext__services={$storeDomain == "services"}  class:domaineintro__habillage__line__ext__amenagements={$storeDomain == "amenagements"}></div>
	</div>
	{#if ($storeDomain == "services")}
	<div class="domaineintro__text">
		Depuis plus de 15 ans, nous offrons les services d’assainissement, de viabilisation et d'aménagements pour particuliers sur la Loire Atlantique. Nous allons, à travers ce site, vous donner une idée sur les différentes activités de l'entreprise ainsi qu’un aperçu sur un certain nombre de nos réalisations. Depuis 2017 notre société s'est également spécialisée dans le Balayage de voirie.<br><br>
		<a href="https://therma-novas.com/mini-piscines-fitness/" target="_blank" rel="noreferrer"><img class="domaineintro__img" src="../images/amenagements/therma_novas.jpg" alt="therma novas"></a>
	</div>
	<div class="domaineintro__text1">
		Depuis plus de 15 ans, nous offrons les services d’assainissement, de viabilisation et d'aménagements pour particuliers sur la Loire Atlantique. Nous allons, à travers ce site, vous donner une idée sur les 
	</div>
	<div class="domaineintro__text2">
		différentes activités de l'entreprise ainsi qu’un aperçu sur un certain nombre de nos réalisations. Depuis 2017 notre société s'est également spécialisée dans le Balayage de voirie.
	</div>
	<div class="domaineintro__text3">
		<a href="https://therma-novas.com/mini-piscines-fitness/" target="_blank" rel="noreferrer"><img class="domaineintro__img" src="../images/amenagements/therma_novas.jpg" alt="therma novas"></a>
   </div>	{:else}
	<div class="domaineintro__text">
		ATTAL AMENAGEMENT est spécialisé dans la mise en œuvre d’enrobés depuis de nombreuses années avec une équipe dédiée à cette activité (pour pro et particuliers).<br><br>Depuis 2 ans nous réalisons également des aménagements en résines drainantes avec l’acquisition de l’agrément <u><b>Résinéo</b></u>  (Fabricant français de résine).<br><br>Nous allons, à travers ce site, vous donner un aperçu sur un certain nombre de nos réalisations. ATTAL est également distributeur et installateur exclusif des mini piscines fitness <u><b>THERMA NOVAS</b></u> sur la Loire Atlantique.
		<br><br>
		 <a href="https://www.resineo.com" target="_blank" rel="noreferrer"><img class="domaineintro__img" src="../images/amenagements/agree_resineo.jpg" alt="resineo"></a><br><br>
		 <a href="https://therma-novas.com/mini-piscines-fitness/" target="_blank" rel="noreferrer"><img class="domaineintro__img" src="../images/amenagements/therma_novas.jpg" alt="therma novas"></a>
	</div>
	<div class="domaineintro__text1">
		ATTAL AMENAGEMENT est spécialisé dans la mise en œuvre d’enrobés depuis de nombreuses années avec une équipe dédiée à cette activité (pour pro et particuliers).<br><br>Depuis 2 ans nous réalisons également des aménagements en résines drainantes avec l’acquisition de l’agrément <u><b>Résinéo</b></u> (Fabricant français de résine).
	</div>
	<div class="domaineintro__text2">
		 Nous allons, à travers ce site, vous donner un aperçu sur un certain nombre de nos réalisations. ATTAL est également distributeur et installateur exclusif des mini piscines fitness <u><b>THERMA NOVAS</b></u> sur la Loire Atlantique.<br><br>
		 <a href="https://www.resineo.com" target="_blank" rel="noreferrer"><img class="domaineintro__img" src="../images/amenagements/agree_resineo.jpg" alt="resineo"></a>
	</div>
	<div class="domaineintro__text3">
		<a href="https://therma-novas.com/mini-piscines-fitness/" target="_blank" rel="noreferrer"><img class="domaineintro__img" src="../images/amenagements/therma_novas.jpg" alt="therma novas"></a>
   </div>
   {/if}

</div>

<style lang="scss">

    .domaineintro {
        display: grid;
		grid-template-areas: 
			"habillage"
			"text";
		grid-template-rows: 40px 1fr;
        width: 100%;
		margin: 0 0 $header-height 0;
		&__habillage {
			grid-area: habillage;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			&__slash {
				transform: rotateZ(180deg);
				width: 66px;
				height: 40px;
			}
			&__line {
				margin-left: -36px;
				margin-right: -$contener-marge-small;
				width: 100%;
				&__services {
					border-bottom: 1px solid $color-bleu-clair-instit;
				}
				&__amenagements {
					border-bottom: 1px solid $color-orange-dde;
				}
			}
		}
		&__text {
			grid-area: text;
			margin: 30px 0 0 0;
		}
		&__text1 {
			display: none;
		}
		&__text2 {
			display: none;
		}
		&__text3 {
			display: none;
		}
		&__img {
			width: 100%;
		}
	}

	@include large {
        .domaineintro {
			grid-template-areas: 
				"vide1 habillage habillage"
				"text1 text2 text3";
			grid-template-columns: 33% 33% 1fr;
			column-gap: 30px;
			row-gap: 30px;
			height: 300px;
			&__amenagements {
				height: 400px;
			}
			&__habillage {
				&__line {
					margin-right: -$contener-marge-large;
					width: $contener-marge-large-pourcent;
				}
			}
			&__text {
				display: none;
			}
			&__text1 {
				display: block;
				grid-area: text1;
			}
			&__text2 {
				display: block;
				grid-area: text2;
			}
			&__text3 {
				display: block;
				grid-area: text3;
			}
			&__img {
				width: 90%;
			}
        }
	}

	@include extra-large {
        .domaineintro {
			&__habillage {
				&__line {
					&__ext {
						position: absolute;
						margin-top: 39px;
						margin-left: 40px;
						width: 2500px;
						&__services {
							border-bottom: 1px solid $color-bleu-clair-instit;
						}
						&__amenagements {
							border-bottom: 1px solid $color-orange-dde;
						}
					}
				}
			}
        }
	}

</style>